import { render, staticRenderFns } from "./cont4.vue?vue&type=template&id=0e5d2cc7&scoped=true"
var script = {}
import style0 from "./cont4.vue?vue&type=style&index=0&id=0e5d2cc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5d2cc7",
  null
  
)

export default component.exports